import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getIsCheckoutLoyaltyInternationalTrip from './getIsCheckoutLoyaltyInternationalTrip'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'

const getCanRedeemTransferLoyaltyBenefit = createSelector(
  (state: App.State) => state.loyalty.account.data?.benefits,
  (state: App.State) => getIsCheckoutLoyaltyInternationalTrip(state),
  (state: App.State) => state.loyalty.config?.transferAirports,
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (
    userBenefits,
    isInternationalTrip,
    airportCodes = EmptyArray,
    isCurrentRegionUserLoyaltyRegion,
    postPurchase,
  ): boolean => {
    if (!isCurrentRegionUserLoyaltyRegion || !!postPurchase) return false
    const transferBenefit = userBenefits?.find(benefit => benefit.code === 'airport_transfer')

    // Can redeem airport transfers when they have some remaining, it's an international order
    // and our config says we have transfer airports available
    return airportCodes.length > 0 &&
      !!transferBenefit &&
      (transferBenefit.unlimited || !!transferBenefit.remaining) &&
      isInternationalTrip
  },
)

export default getCanRedeemTransferLoyaltyBenefit
